import { SVGInjector } from '@tanem/svg-injector';
import { DomComponentHander } from './Handler';
export class SVGInject extends DomComponentHander {
    static DomContentLoaded() {
        document.querySelectorAll('img[src$=".svg"]').forEach(element => {
            SVGInjector(element, {});
        });
    }
}
